
import { Component, Prop, Vue } from "vue-property-decorator";
import { PayrollAssignDto, RefundDetailDto } from "@/api/appService";

@Component({ name: "RefundDetail" })
export default class RefundDetail extends Vue {
  @Prop()
  detail: any;

  show: boolean = false;

  handleClose() {
    this.show = false;
  }
}
